/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-30 13:58:17
 * @Description: 
 */

import React from "react";
import "./FTNoImageMobile.scss"
import { IconPlus } from "src/assets"
import FTLang from "src/utils/FTLang";
import FTImageStore from "src/store/FTImageStore";
import FTNoImageLinkToAIGC from "./FTNoImageLinkToAIGC/FTNoImageLinkToAIGC"
export default function FTNoImageMobile() {
  const uploadImage = async () => {
    FTImageStore.uploadImage("goart_noimage")
  }
  return <div className="noimage_mobile">
      <FTNoImageLinkToAIGC />
      <div className="noimage_mobile_center" onClick={uploadImage}>
        <div>
          <IconPlus className="noimage_mobile_icon" />
          <div className="noimage_mobile_text">
            {FTLang._("goart_open_image")}
          </div>
        </div>
      </div>
    </div>
}